// extracted by mini-css-extract-plugin
export default {"rank":"treadwell-icon__rank___1n9Q2"};